import { BsCheck2Circle } from 'react-icons/bs'
import HeadingTexts from '../../common/HeadingTexts';
import image from "../../../Assets/About/scientists.jpg"

const serviceList = [
  {
    label: 'Quality ', text: 'Accurate and reliable results in every test.'
  },
  {
    label: 'Innovation ', text: 'Leveraging advanced laboratory technology and best practices.'
  },
  {
    label: 'Integrity ', text: 'Ethical and transparent in all processes.'
  },
  {
    label: 'Timeliness  ', text: 'Delivering results when they matter most.'
  },
  {
    label: 'Reach & Inclusion ', text: ' Ensuring healthcare access for every community, including remote areas.'
  },
]

const AboutExplore = () => {
  return (
    <div className='bg-[#fafafa]  md:px-10 px-6'>
      <section className='flex flex-col xl:flex-row gap-10 xl:items-start py-10'>
        <figure data-aos="fade-up" data-aos-duration="700" className='xl:w-[550px] xl:h-[550px] rounded-3xl overflow-hidden shadow-sm'><img className='w-full h-full object-cover object-center' src={image} alt="img" /></figure>
        <article className='flex-1 flex flex-col gap-y-5 justify-between h-full items-stretch'>
          <HeadingTexts label='Core Values' text='The Pillars of Trust and' bluetext='Excellence in Healthcare' />
          <p data-aos="fade-up" data-aos-duration="700" className="text-sm md:text-[1rem] font-normal leading-relaxed max-w-2xl text-[#5a5a5a] mb-5">
            Diagnonext Labs Pvt Ltd is a high-end pathology laboratory dedicated
            to delivering accurate, reliable, and timely diagnostic services
            across India. Led by experienced pathologists and industry leaders and
            equipped with state-of-the-art laboratory technology, we ensure
            precision, reliability, and trust in every report. Our commitment to
            quality, affordability, and patient-centric care makes us a preferred
            partner for individuals, hospitals, clinics, and healthcare providers.
          </p>
          <div className="flex flex-col gap-y-5">
            {
              serviceList.map(({ label, text }, index) => (
                <div data-aos="fade-up" data-aos-duration="700" key={index} className='flex gap-5 items-center'>
                  <span className="text-[#4f4f4f] text-2xl p-2 rounded-full bg-[#e3ffeb]"><BsCheck2Circle /></span>
                  <article className='flex flex-col gap-y-1'>
                    <h1 className='text-lg font-semibold'>{label}</h1>
                    <p className='text-[#4f4f4f]'>{text}</p>
                  </article>
                </div>
              ))
            }
          </div>
        </article>
      </section>
    </div>
  )
}

export default AboutExplore;